// removed by extract-text-webpack-plugin
module.exports = {"root":"_3u7Pzhm","searchbar_isExpanded":"_3MUYzIo","dashboard_isOpen":"_1q-ys29","searchbar_isCollapsed":"_3hRRmf_","worktype_isOpen":"_3-ZByEq","salary_isOpen":"_1HQt6z-","datelisted_isOpen":"_2GZtrz5"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ContentSpacer/ContentSpacer.less
 ** module id = 746
 ** module chunks = 0
 **/